import { render } from "./LoginPlease.vue?vue&type=template&id=2bb3233e"
import script from "./LoginPlease.vue?vue&type=script&lang=js"
export * from "./LoginPlease.vue?vue&type=script&lang=js"

import "./LoginPlease.vue?vue&type=style&index=0&id=2bb3233e&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__